import { useMemo } from 'react';
import { useFm, useParams } from '@web3/base-hooks';
import { appPath, showShareModal, toFormat, isBrowser } from '@web3/base-utils';
import {
  DEFAULT_VAL,
  TOTAL_REWARD_AMOUNT,
  WSOT_HOME_PAGE,
} from '@/utils/constant';

interface IProps {
  rewardAmount?: string;
  projectNum: number | string;
  joinAddressCount: number | string;
  isProfile?: boolean;
}

/**  wsot首页 分享 */
export const useWsotShare = ({
  rewardAmount = TOTAL_REWARD_AMOUNT,
  projectNum = DEFAULT_VAL,
  joinAddressCount = DEFAULT_VAL,
  isProfile,
}: IProps) => {
  const fm = useFm();
  const { locale } = useParams();

  const shareUrl = useMemo(() => {
    return `${isBrowser ? `${window.location.origin}` : ''}/${locale}${WSOT_HOME_PAGE}?utm_content=${isProfile ? 'ishare' : 'homeshare'}`;
  }, [locale]);

  const showShare = () => {
    showShareModal({
      posterStyle: ['vertical'],
      link: shareUrl,
      content: `${fm('joinBybitAIDolSuperstar', { amount: rewardAmount })} ${shareUrl}`,
      channels: ['facebook', 'twitter', 'whatsapp', 'telegram', 'linkedin'],
      templateData: {
        showLogo: true,
        backgroundImage: {
          // 图片只能放项目里
          vertical: `${appPath}/png/profile/share-home-bg.png`,
        },
        content: {
          desc: `<div class="share-content-wrap" style="margin-top: -17px;">
                  <div class="share-date">${'2025.2.28 00:00 UTC - 2025.3.27 23:59 UTC'}</div>
                  <img clss="w-[280px]" src="https://s1.bycsi.com/bybit/deadpool/image-15832a676bc9452bad0a46f5603c6307.png" />
                  <p class="mt-[8px] text-sm font-normal whitespace-pre-line" style="width: 280px;">${fm('bybitAiDolSuperstarHome')}</p>

                  <p class="font-extrabold mt-[8px] text-[18px] leading-[1.2]">
                    ${fm('castVoteSharePrizePoolHome', {
                      amount: `<span class="sky-blue-color">
                                ${rewardAmount}
                              </span>`,
                    })}
                  </p> 

                  <div class="share-green-box share-supporter-box-height flex justify-between items-center mt-4" 
                    style="padding: 14px 0;"
                  > 
                    <div style="width: 130px"> 
                      <h5 class="text-[12px] leading-[1.8] mb-[4px]">${fm('projects')}</h5>  
                      <p class="text-[16px] leading-[1] font-extrabold">${toFormat(projectNum, 0)}</p>  
                    </div>

                    <span class="share-divide-line"></span>  

                     <div style="width: 130px"> 
                      <h5 class="text-[12px] leading-[1.8] mb-[4px]">${fm('supporters')}</h5>  
                      <p class="text-[16px] leading-[1] font-extrabold">${toFormat(joinAddressCount, 0)}</p>
                    </div>
                  </div>
                </div>`,
        },
        bottom: {
          showCode: false,
          desc: fm('scanToVoteAndShare'),
        },
      },
    });
  };

  return {
    showShare,
  };
};
